import { render, staticRenderFns } from "./Profile.Dashboard.Address.vue?vue&type=template&id=5bacaac9&scoped=true"
import script from "./Profile.Dashboard.Address.vue?vue&type=script&lang=js"
export * from "./Profile.Dashboard.Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bacaac9",
  null
  
)

export default component.exports